/**
 * Created by Stefano Mandruzzato on 20/11/18.
 */
'use strict';
export default class LmrcApiService {

    constructor($q, $log, $http, API_CONFIG, $ngRedux) {
        'ngInject';

        this._logger = $log.getInstance('LmrcApiService');
        this._$q = $q;
        this.$http = $http;
        this.API_CONFIG = API_CONFIG;
        this.$ngRedux = $ngRedux;
        this._logger.log('instantiated');
        this.cache = {};
    }


    createSession(request) {
        this._logger.log('createSession', request);
        return this.$http.post(this.API_CONFIG.basePath + '/session', request)
    }

    startMigration(request) {
        this._logger.log('startMigration', request);
        var vm = this;
        return this.$http.post(this.API_CONFIG.basePath + '/migration', request)
            .then(function(body) {
                return vm.callUpdateUserAgreements()
                    .then((ignore) => vm._$q.resolve(body));
            });
    }

    getContactInfo(request) {
        this._logger.log('getContactInfo', request);
        return this.$http.get(this.API_CONFIG.basePath + '/user/contactinfo', request)
    }

    updateUserAgreements(request) {
        this._logger.log('updateUserAgreements', request);
        this.cache["user-agreements"] = request;
        this._logger.log('cache["user-agreements"]', this.cache["user-agreements"]);
        return this._$q.resolve();
    }

    callUpdateUserAgreements() {
        var request = this.cache["user-agreements"];
        this._logger.log('callUpdateUserAgreements', request);
        return this.$http.put(this.API_CONFIG.basePath + '/user/agreements', request)
    }

    getUserAgreements(request) {
        this._logger.log('getUserAgreements', request);
        return this.$http.get(this.API_CONFIG.basePath + '/user/agreements', request)
    }


    updateContactInfo(request) {
        this._logger.log('updateContactInfo', request);
        return this.$http.put(this.API_CONFIG.basePath + '/user/contactinfo', request)
    }

    getCustomization(customizationId) {
        this._logger.log('getCustomization', customizationId);
        return this.$http.get(this.API_CONFIG.basePath + '/personalization/' + customizationId)
    }

    changePassword(thepassword) {
        this._logger.log('changePassword', thepassword);
        var vm = this;
        // return this.$http.post(this.API_CONFIG.basePath + '/user/password', request);
        return this.$http({
            method: 'POST',
            url: this.API_CONFIG.basePath + '/user/password',
            data: $.param({ password: thepassword }),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        });
    }
}


// WEBPACK FOOTER //
// ./client/components/api-service/lmrc-api.service.js